import { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import PageHeader from "../-components/PageHeader";
import ConsoleHrozontalHeadTable from "../-components/ConsolehorizontalHeadTable";
import LoadingPop from "components/popup/LoadingPop";
import ConfirmDialog from "components/popup/ConfirmDialog";
import Seo from "components/Seo";
import WarehouseForm, { WarehouseFormState } from "./WarehouseForm";
import { useGetConsoleWarehouseDetail, useDeleteConsoleWarehouse } from "hooks/console/useConsoleWarehouse";

export default function ConsoleWarehouseDetail() {
    const navigate = useNavigate();
    const location = useLocation();
    const idx = useParams().idx ?? "";
    const page = location.state?.page ?? "1";
    const [editMode, setEditMode] = useState(false);
    const { data, isLoading } = useGetConsoleWarehouseDetail(idx);
    const { mutate: deleteWarehouse } = useDeleteConsoleWarehouse(() => navigate(`/morning/customer/warehouse?page=${page}`));
    const [form, setForm] = useState<WarehouseFormState>({
        warehouse_no: null,
        port_name: "",
        name: "",
        driver_no: "",
        post: "",
        address: "",
        addressDetail: "",
    });

    useEffect(() => {
        if (data) {
            setForm({
                warehouse_no: data.warehouse_no,
                port_name: data.port_name || "",
                name: data.name || "",
                driver_no: data.driver_no != null ? String(data.driver_no) : "",
                post: data.post || "",
                address: data.address1 || "",
                addressDetail: data.address2 || "",
            });
        }
    }, [data]);

    const thead = [
        { title: "항구명", key: "port_name" },
        { title: "입고지명", key: "name" },
        {
            title: "담당기사",
            key: "driver_name",
            content: (value: string) => <span>{value || "-"}</span>,
        },
        {
            title: "주소",
            key: "post",
            content: (_value: string, row: any) => (
                <span>{[row.post && `(${row.post})`, row.address1, row.address2].filter(Boolean).join(" ") || "-"}</span>
            ),
        },
    ];

    if (!idx) return <div>잘못된 접근입니다.</div>;

    return (
        <>
            <Seo type="console" pageTitle="입고지 관리" />
            <div className="flex-1 flex flex-col overflow-hidden max-h-[100dvh]">
                <PageHeader category="고객서비스" title="입고지 상세" />
                <div className="flex-1 bg-[#F7F6FB] flex overflow-hidden">
                    <div className="px-[40px] py-[28px] w-full overflow-auto">
                        {isLoading ? (
                            <LoadingPop />
                        ) : data ? (
                            <div className="bg-white rounded-[20px] py-[36px] px-[40px] w-full min-w-[800px] h-full">
                                {editMode ? (
                                    <WarehouseForm form={form} setForm={setForm} setEditMode={setEditMode} update />
                                ) : (
                                    <>
                                        <ConsoleHrozontalHeadTable thead={thead} tbody={data} />
                                        <div className="flex justify-center gap-x-[8px] mt-5">
                                            <button
                                                className="text-[#666666] text-[18px] bg-white rounded-[5px] border border-[#dddddd] px-[55px] py-[15px]"
                                                onClick={() => setEditMode(true)}
                                            >
                                                수정
                                            </button>
                                            <ConfirmDialog
                                                title="입고지 삭제"
                                                trigger={open => (
                                                    <button
                                                        type="button"
                                                        onClick={open}
                                                        className="text-[#666666] text-[18px] bg-white rounded-[5px] border border-[#dddddd] px-[55px] py-[15px]"
                                                    >
                                                        삭제
                                                    </button>
                                                )}
                                                handleConfirm={() => deleteWarehouse({ warehouse_no: [Number(idx)] })}
                                            />
                                            <button
                                                onClick={() => navigate(`/morning/customer/warehouse?page=${page}`)}
                                                className="text-white text-[18px] bg-[#4F46E5] rounded-[5px] border border-[#666666] px-[55px] py-[15px]"
                                            >
                                                목록
                                            </button>
                                        </div>
                                    </>
                                )}
                            </div>
                        ) : (
                            <div className="bg-white rounded-[20px] flex flex-col gap-5 items-center justify-center py-[100px]">
                                <p>결과가 없습니다.</p>
                                <button onClick={() => navigate(-1)} className="rounded-[8px] border px-5 py-2">
                                    뒤로가기
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}
